
export default [
    {
        path: '/',
        // name: 'layout',
        component: () => import('../layout/Layout.vue'),
        children: [
            {
                path: '/',
                name: 'index',
                component: () => import('../views/Index.vue'),
            },
            {
                path: '/user',
                name: 'user',
                component: () => import('../views/user/User.vue'),
            },
            {
                path: '/groups',
                name: 'groups',
                component: () => import('../views/user/Groups.vue'),
            },
            {
                path: '/customer',
                name: 'customer',
                component: () => import('../views/adPromotion/Customer.vue'),
            },
			{
			    path: '/copyaccount',
			    name: 'copyaccount',
			    component: () => import('../views/adPromotion/Copyaccount.vue'),
			},
            {
                path: '/adver',
                name: 'adver',
                component: () => import('../views/adPromotion/Adver.vue'),
            },
            {
                path: '/task',
                name: 'task',
                component: () => import('../views/adPromotion/Task.vue'),
            },
            {
                path: '/reports',
                name: 'reports',
                component: () => import('../views/adPromotion/Reports.vue'),
            },

            //dong
            {
                path: '/source',
                name: 'source',
                component: () => import('../views/source/Source.vue'),
            },
            {
                path: '/upload',
                name: 'upload',
                component: () => import('../views/source/Upload.vue'),
            },
            {
                path: '/editSource',
                name: 'editSource',
                component: () => import('../views/source/EditSource.vue'),
            },
            {
                path: '/template',
                name: 'template',
                component: () => import('../views/template/Template.vue'),
            },
            {
                path: '/need',
                name: 'need',
                component: () => import('../views/need/Need.vue'),
            },
            {
                path: '/table',
                name: 'table',
                component: () => import('../views/need/Table.vue'),
            },
            //角色管理
            {
                path: '/roles',
                name: 'roles',
                component: () => import('../views/roles/Roles.vue'),
            },
            //菜单管理
            {
                path: '/menus',
                name: 'menus',
                component: () => import('../views/menus/Menus.vue'),
            },
            //功能管理
            {
                path: '/actions',
                name: 'actions',
                component: () => import('../views/actions/Actions.vue'),
            },
            //日志管理
            {
                path: '/log',
                name: 'log',
                component: () => import('../views/log/Log.vue'),
            },
            //媒体管理
            {
                path: '/media',
                name: 'media',
                component: () => import('../views/media/Media.vue'),
            },
            //渠道列表
            {
                path: '/canal',
                name: 'canal',
                component: () => import('../views/canal/Canal.vue'),
            },
            //财务转账
            {
                path: '/money',
                name: 'money',
                component: () => import('../views/money/Money.vue'),
            },
			{
			    path: '/finance',
			    name: 'finance',
			    component: () => import('../views/money/Finance.vue'),
			},

        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../login/login.vue'),
    },
    {
        path: '/ceshi',
        name: 'ceshi',
        component: () => import('../views/Ceshi.vue'),
    },
    {
        path: '/*',
        component: () => import('../views/404.vue'),
    },
    // {
    //     path: '*',
    //     redirect: '/404',
    // },
]